export default __webpack_public_path__ + "static/media/gallery_16.837fe289.jpg";